import { makeEntityIdentifier } from '@neptune/shared/entity-util';

export type ShortIdsByProject = Map<string, string[]>;

export function isEmptyShortIdsMap(shortIdsByProject: ShortIdsByProject): boolean {
  return Array.from(shortIdsByProject.values()).every((shortIds) => shortIds.length === 0);
}

export function isSingleElementShortIdsMap(shortIdsByProject: ShortIdsByProject): boolean {
  const arr = Array.from(shortIdsByProject.values());
  const singleIdx = arr.findIndex((shortIds) => shortIds.length === 1);
  return (
    singleIdx !== -1 && arr.every((shortIds, idx) => shortIds.length === 0 || idx === singleIdx)
  );
}

export function singleProjectShortIdsMap(projectIdentifier: string, shortIds: string[]) {
  return new Map([[projectIdentifier, shortIds]]);
}

export function getUniqueShortIds(shortIdsByProject: ShortIdsByProject): string[] {
  return Array.from(
    new Set(
      Array.from(shortIdsByProject.entries()).flatMap(([project, ids]) =>
        ids.map((id) => makeEntityIdentifier(project, id)),
      ),
    ),
  );
}
